import { Container } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';

import { Context as AuthContext } from '../../Redux/context/AuthContext';

import styled from '@material-ui/core/styles/styled';

import { Nav, Navbar } from 'react-bootstrap';
import styles from './style.module.scss';
import Button from '../../components/Button';
import { Box } from '../Layouts';
import IconButton from '@material-ui/core/IconButton';
import DescriptionIcon from '@material-ui/icons/Description';
import Tooltip from '@material-ui/core/Tooltip';
import NotificationIcon from '@material-ui/icons/Notifications';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ExitToApp from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import MenuIcon from '@material-ui/icons/Menu';
import GoogleLogin from 'react-google-login';
import SearchInput from '../SearchBox/searchInput';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { HiOutlineSearch } from 'react-icons/hi';
import {
  getNotificationCount,
  getNotifications,
  readAllNotification,
} from '../../Redux/actions/notificationAction';
import { useDispatch, useSelector } from 'react-redux';
import { AnnouncementLabel } from '../Toolbar/utils';
import { dataFormatter } from '../../utils/formatter';
import { Link } from '../SideNav';
import { moengageTrackEvent } from '../../Analytics/moengageEventFunction';
import Dialog from '../Dialog';
import TermsAndConditionPage from '../../pages/TermsAndCondition';
import { StyledCard } from '../Toolbar';
import NotificationCard from '../NotificationCard';
import useOutsideClick from '../../utils/hooks/useOutsideClick';
import SelectList from '../Select/selectList';
import getApobSupplierId from '../../utils/getApobSupplierId';
import { setApobSeller } from '../../Redux/actions/setApobSellerAction';
import { MILISECONDS_IN_MINUTE } from '../../utils/utils';
import useAdmin from '../../hooks/useAdmin';
import { arzoooS3Url, isProd } from '../../utils/checkMode';

const NewHeaderComponent = (props) => {
  const { logout } = React.useContext(AuthContext);
  const [isNotifcnOpen, toggleNotification] = React.useState(false);
  const [openMenu, setMenuOpen] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [agreementOpen, setAgreementOpen] = useState(false);

  const [sellerList, setSellerList] = useState([]);
  const [showApobList, setShowApobList] = useState(false);

  const [isAdmin] = useAdmin();

  const setSelectedSeller = (supplierDetails) => {
    if (supplierDetails?.apobSupplierID) {
      dispatch(setApobSeller(supplierDetails));
    }
  };

  const AppIcon = styled('img')(() => ({
    height: '2.22rem',
    cursor: 'pointer',
    marginRight: '0.625rem',
  }));

  const { count, list } = useSelector((state) => state.notification);

  const { apobSellerList } = useSelector((state) => {
    return state.apobSeller;
  });
  const { apobSupplierID } = getApobSupplierId();

  useEffect(() => {
    if (apobSellerList) {
      setSellerList(apobSellerList.apobSellerList);
      if (loginData?.user_id) {
        setSelectedSeller({
          apobSupplierID: loginData?.user_id,
          isClearTaxInvoice: loginData?.isClearTaxInvoice,
          isIrnNeeded: loginData?.isIrnNeeded,
        });
      }
      if (apobSellerList?.apobSellerList && apobSellerList.apobSellerList.length > 1) {
        setShowApobList(true);
      }
    }
  }, [apobSellerList]);

  // Call Notification count API when page is rerendered
  useEffect(() => getNotifcnCount(), []);
  // Call Notification count API in every 20 - 30 min
  let MS_IN_5_MIN = MILISECONDS_IN_MINUTE * 5;
  useEffect(() => {
    let timer = setInterval(() => {
      getNotifcnCount();
    }, MS_IN_5_MIN);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const dispatch = useDispatch();

  const ref = React.useRef(null);
  const anchorRef = React.useRef(null);

  const loginData = localStorage.getItem('login_data')
    ? JSON.parse(localStorage.getItem('login_data'))
    : null;

  const dayDifference = loginData?.salesDays;

  const salesBoostOn = loginData?.salesBoostOn;

  const handleOpenPdf = () => {
    let url = arzoooS3Url + '/falcon-nic-doc/GST+API+Credentials+Process+Flow.pdf';
    window.open(url, '_blank');
  };

  const referNow = () => {
    let url = isProd
      ? 'https://referals.arzoopro.com/referal?from=website&user=na'
      : 'https://referals.dev.arzoopro.com/referal?from=website&user=na';
    window.open(url, '_blank');
  };

  const fetchNotifications = () => dispatch(getNotifications(apobSupplierID));

  const readAll = () => {
    dispatch(readAllNotification(apobSupplierID));
    toggleNotification(false);
  };

  const getNotifcnCount = () => {
    dispatch(getNotificationCount(apobSupplierID));
  };

  useOutsideClick(ref, () => {
    if (isNotifcnOpen) {
      toggleNotification(false);
    }
  });

  const handleDialogAction = (flag) => {
    if (flag) endSession();
    setDialogOpen(false);
  };

  const endSession = async () => {
    await logout();
  };

  const handleChangeSeller = (item) => {
    setSelectedSeller(item);
    // dispatch(setApobSeller(item.value));
  };

  return (
    <Container style={{ position: 'fixed', zIndex: '1000' }} className="p-0" maxWidth="">
      <Navbar className={`${styles.headerStyles} justify-content-end-between`}>
        <Navbar.Brand href="/dashboard">
          <div className={styles.imageContainer}>
            <img
              alt="arzooo-header-logo"
              className={styles.headerLogo}
              src="https://static.arzoopro.com/images/falcon-logo.png"
            ></img>
          </div>
        </Navbar.Brand>

        <Typography variant="h6" noWrap style={{ marginLeft: '5rem' }}>
          {showApobList ? (
            <SelectList
              showAdminTag={true}
              list={sellerList.map((item) => {
                return {
                  label: item.name,
                  apobSupplierID: item.supplierId,
                  isClearTaxInvoice: item.isClearTaxInvoice,
                  isIrnNeeded: item.isIrnNeeded,
                };
              })}
              selected={apobSupplierID}
              onChange={handleChangeSeller}
            />
          ) : (
            <span className={`${styles.headerFont}`}>
              {isAdmin
                ? ((loginData?.sellerName && loginData?.sellerName.toUpperCase()) || '-') +
                  ' (Admin)'
                : (loginData?.name && loginData?.name.toUpperCase()) || '-'}
            </span>
          )}
        </Typography>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        {/* <Navbar.Collapse id="responsive-navbar-nav"> */}
        <Nav
          className={`${
            loginData?.userJourneyCompleted
              ? salesBoostOn
                ? styles.wideContainer
                : styles.narrowContainer
              : ''
          } justify-content-end align-items-center flex-grow-1`}
        >
          {loginData?.userJourneyCompleted && salesBoostOn && (
            <span className={`mr-2 ${styles.salesBoost}`}>
              Sales boost is <b>ON! {dayDifference} days</b> left
            </span>
          )}
          <AppIcon
            src="/images/download-now2.gif"
            onClick={() => {
              window.open('https://play.google.com/store/apps/details?id=com.arzooofalcon');
            }}
          />

          {(loginData?.userJourneyCompleted || loginData?.isAdmin) && (
            <Box>
              {
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => window.open('https://einvoice1.gst.gov.in')}
                  moenagage-id={JSON.stringify({
                    eventName: 'Seller_learning_platform',
                    eventDetails: 'clicked on Create your e-invoice button',
                  })}
                >
                  Auto Invoice
                </Button>
              }
              {
                <Tooltip title="Click here to know how to generate e-Invoice API credentails">
                  <IconButton
                    onClick={handleOpenPdf}
                    moenagage-id={JSON.stringify({
                      eventName: 'Seller_learning_platform',
                      eventDetails: 'clicked on Pdf tutorial',
                    })}
                  >
                    <DescriptionIcon style={{ color: 'gray', width: 30, height: 30 }} />
                  </IconButton>
                </Tooltip>
              }
            </Box>
          )}

          {(loginData?.userJourneyCompleted || loginData?.isAdmin) && (
            <Box ref={ref} style={{ paddingRight: '10px' }}>
              <IconButton
                onClick={() => {
                  toggleNotification(!isNotifcnOpen);
                  fetchNotifications();
                }}
              >
                <Badge
                  badgeContent={count}
                  color="primary"
                  moenagage-id={JSON.stringify({
                    eventName: 'Home_page_notifications_clicked',
                    eventDetails: 'Notification clicked and viewed',
                  })}
                >
                  <NotificationIcon />
                </Badge>
              </IconButton>
            </Box>
          )}

          {(loginData?.userJourneyCompleted || loginData?.isAdmin) && (
            <Box onClick={referNow} style={{ paddingRight: '5px' }}>
              <AnnouncementLabel style={{ fontSize: '10px' }}>
                Win upto {dataFormatter(25000, 'currency')}
              </AnnouncementLabel>
              <IconButton>
                <span className="arz-announcement" style={{ fontSize: 'inherit' }} />
              </IconButton>
            </Box>
          )}

          {(loginData?.userJourneyCompleted || loginData?.isAdmin) && (
            <Tooltip title="Logout" arrow>
              <IconButton
                variant={'outlined'}
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={() => setMenuOpen((prevOpen) => !prevOpen)}
              >
                {/* <span className="arz-user" /> */}
                <ExitToApp fontSize="inherit" />
              </IconButton>
            </Tooltip>
          )}

          <Popper
            open={openMenu}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                  width: '10rem',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
                    <MenuList autoFocusItem={open} id="menu-list-grow">
                      <Link
                        to={{
                          pathname: '/vendor-details',
                          state: { source: 'from profile section on header' },
                        }}
                      >
                        <MenuItem onClick={() => setMenuOpen(false)}>Profile</MenuItem>
                      </Link>
                      <MenuItem
                        onClick={() => {
                          setAgreementOpen(true);
                          setMenuOpen(false);
                          moengageTrackEvent('Seller_agreement_viewed', {});
                        }}
                      >
                        <span>Seller Agreement</span>
                      </MenuItem>
                      <MenuItem onClick={() => setDialogOpen(true)}>Logout</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>

          {dialogOpen ? <Dialog open={dialogOpen} onAction={handleDialogAction} /> : null}

          {agreementOpen && (
            <TermsAndConditionPage
              agreementOpen={agreementOpen}
              closeAgreementOpen={setAgreementOpen}
              showTerms={true}
              showWorkingHours={true}
              disableButtons={true}
              showClose={true}
            />
          )}

          {isNotifcnOpen && (
            <StyledCard onClick={(e) => e.stopPropagation()} style={{ width: '25rem' }}>
              <NotificationCard notifications={list} onReadAll={readAll} />
            </StyledCard>
          )}
        </Nav>
        {/* </Navbar.Collapse> */}
      </Navbar>
    </Container>
  );
};
export default NewHeaderComponent;
